import { render, staticRenderFns } from "./BalanceLogPage.vue?vue&type=template&id=4f078116&scoped=true"
import script from "./BalanceLogPage.vue?vue&type=script&lang=js"
export * from "./BalanceLogPage.vue?vue&type=script&lang=js"
import style0 from "./BalanceLogPage.vue?vue&type=style&index=0&id=4f078116&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f078116",
  null
  
)

export default component.exports